import { render, staticRenderFns } from "./organization-question-set-and-survey.vue?vue&type=template&id=3259fd60&scoped=true"
import script from "./organization-question-set-and-survey.vue?vue&type=script&lang=js"
export * from "./organization-question-set-and-survey.vue?vue&type=script&lang=js"
import style0 from "./organization-question-set-and-survey.vue?vue&type=style&index=0&id=3259fd60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3259fd60",
  null
  
)

export default component.exports